import type { CampEventSettings } from "@/server/platform/db/schema/camp-registrations";

/** อ่าน package template ids — รองรับ legacy `packageTemplateId` เดิม */
export function resolveCampPackageTemplateIds(
  settings: CampEventSettings | null | undefined,
): string[] {
  if (!settings) return [];

  const fromArray = settings.packageTemplateIds?.filter(Boolean) ?? [];
  if (fromArray.length > 0) return [...new Set(fromArray)];

  if (settings.packageTemplateId?.trim()) {
    return [settings.packageTemplateId.trim()];
  }

  return [];
}

export function resolveCampDefaultStudentGroupId(
  settings: CampEventSettings | null | undefined,
): string | null {
  const id = settings?.defaultStudentGroupId?.trim();
  return id || null;
}

export function normalizeCampEventSettings(
  settings: CampEventSettings | null | undefined,
): CampEventSettings {
  const packageTemplateIds = resolveCampPackageTemplateIds(settings);
  return {
    packageTemplateIds,
    packageTemplateId: packageTemplateIds[0] ?? null,
    defaultStudentGroupId: resolveCampDefaultStudentGroupId(settings),
  };
}
